var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{ref:"formRef",staticClass:"py-3",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }